import PropTypes from 'prop-types';

function Modal({ children }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="w-[340px] rounded-[10px] bg-white p-4 shadow-[0px_4px_20px_rgba(0,0,0,0.15)]">
        {children}
      </div>
    </div>
  );
}

Modal.Title = function ModalTitle({ title }) {
  return <h2 className="mb-4 text-2xl font-semibold">{title}</h2>;
};

Modal.Message = function ModalMessage({ message }) {
  return <p className="text-gray mb-6">{message}</p>;
};

Modal.ButtonRow = function ModalButtonRow({ children }) {
  return <div className="flex justify-between gap-2">{children}</div>;
};

Modal.propTypes = {
  children: PropTypes.node,
};

Modal.Title.propTypes = {
  title: PropTypes.string.isRequired,
};

Modal.Message.propTypes = {
  message: PropTypes.string.isRequired,
};

Modal.ButtonRow.propTypes = {
  children: PropTypes.node,
};

export default Modal;
